export type Tomo = {
  number: number;
  title: string;
  subtitle?: string;
  description: string;
};
export type Bono = {
  number: number;
  title: string;
  description: string;
  price: string;
};
export type Testimonial = {
  initials: string;
  name: string;
  location: string;
  quote: string;
};
export type Faq = {
  question: string;
  answer: string[];
};
export const painPoints: string[] = ["Desayuno \"sano\" pero igual la hinchazón permanece.", "Almuerzo normal pero a media tarde llega una sensación de pesadez y cansansio", 'Noches donde no sabés si fue la comida, el estrés o mala suerte.', 'Horas perdidas buscando qué deberías comer, sin instrucciones claras.', 'Culpa permanente porque "comés bien pero el cuerpo no responde".'];
export const tomos: Tomo[] = [{
  number: 1,
  title: 'El Despertar',
  description: 'Por qué comés "sano" pero seguís inflamada. Cómo el intestino influye en hinchazón, cansancio, dolores y otros síntomas que probablemente normalizaste.'
}, {
  number: 2,
  title: 'Protocolo Reset',
  subtitle: 'Fase 1 — Días 1 a 7',
  description: 'Guía completa de los primeros 7 días para reducir irritantes, simplificar la alimentación y darle descanso total al sistema digestivo.'
}, {
  number: 3,
  title: 'Protocolo Reintegro',
  subtitle: 'Fase 2 — Días 8 a 15',
  description: 'Paso a paso para reintroducir alimentos ordenadamente y descubrir cuáles detonan hinchazón, cansancio, gases o malestar.'
}, {
  number: 4,
  title: 'Botiquín Natural',
  description: 'Hábitos, suplementos seguros, infusiones, nervio vago y estrategias para acompañar tu reparación intestinal.'
}, {
  number: 5,
  title: 'Recetario Salud Plena',
  description: "50 recetas simples, prácticas y antiinflamatorias. Comida que cura sin ser restrictiva ni aburrida."
}, {
  number: 6,
  title: 'Estilo de Vida Pro-Longevidad',
  description: 'Cómo mantener resultados indefinidamente. Hábitos para prevenir recaídas y construir una rutina más saludable a largo plazo.'
}];
export const bonos: Bono[] = [{
  number: 1,
  title: 'Diario Anti-Hinchazón 15 Días',
  description: 'Registrá comidas, síntomas, energía y sueño e identificá patrones. Descubrí exactamente qué alimentos detonan tu hinchazón y cuáles te hacen sentir bien.',
  price: "7,00 €"
}, {
  number: 2,
  title: 'Lista Inteligente de Compras Salud Plena',
  description: 'Sabé exactamente qué comprar, qué evitar y cómo organizar tu cocina. Se termina la confusión de "¿esto puedo comerlo o no?". Todo claro y listo.',
  price: "9,00 €"
}, {
  number: 3,
  title: 'Plan SOS 48 Horas para Brotes de Inflamación',
  description: 'Si aparece hinchazón o malestar, tenés una guía rápida para volver a lo simple y recuperarte en 48 horas sin abandonar todo.',
  price: "8,00 €"
}, {
  number: 4,
  title: 'Kit Comer Fuera Sin Inflamarte',
  description: 'Estrategias para restaurantes, reuniones familiares, viajes y vida social. Comé conscientemente sin volver a casa hinchada, culpable o confundida.',
  price: "11,00 €"
}, {
  number: 5,
  title: 'Ritual Digestivo Nocturno Naturia',
  description: 'Una rutina simple de 20 minutos para mejorar la digestión nocturna, dormir profundo y despertar sin hinchazón. La noche que te devuelve tu cuerpo.',
  price: '8,00 €'
}];
export const miniTestimonials: Testimonial[] = [{
  initials: 'MV',
  name: 'María V.',
  location: 'Valencia, España',
  quote: "Después de 2 semanas me sentí diferente. La primera semana me costó un poco, pero por fin estoy empezando a entender qué alimentos me sientan peor."
}, {
  initials: 'LC',
  name: 'Laura C.',
  location: 'Madrid, España',
  quote: "Me sentí muy identificada con tu experiencia cuando contabas que estabas cansada de que los médicos dijeran que todo estaba bien, aunque tú no te sintieras así. También me identifiqué con eso de tener 35 años y sentirte de 65. Muy recomendable, aunque algunas recetas me costaron un poco porque no se me da muy bien cocinar."
}, {
  initials: 'AP',
  name: 'Ana P.',
  location: 'Sevilla, España',
  quote: "Lo que más me gustó es que te enseña a prestar atención a tu cuerpo. Al principio me costó porque no me gusta mucho cocinar, pero ahora entiendo mucho mejor qué alimentos me sientan bien y cuáles no."
}];

export const testimonials: Testimonial[] = [{
  initials: 'MV',
  name: 'María V.',
  location: 'Madrid, España',
  quote: "Lo compré un domingo por la noche. El lunes ya tenía mucho más claro qué comer, qué evitar y cómo organizarme. Me ha resultado muy útil tenerlo todo explicado paso a paso."
}, {
  initials: 'JL',
  name: 'Juan L.',
  location: 'Barcelona, España',
  quote: "Lo que más me gustó es que te enseña a escuchar tu cuerpo. Dejé de darle vueltas a qué estaba haciendo mal y empecé a organizar mis hábitos desde cero."
}, {
  initials: 'AP',
  name: 'Ana P.',
  location: 'Valencia, España',
  quote: "Llevaba mucho tiempo intentando organizar mejor mis hábitos. Ahora tengo una rutina más clara y sé mejor qué cosas me sientan bien. Es sencillo de seguir y muy práctico."
}, {
  initials: 'CR',
  name: 'Carla R.',
  location: 'Sevilla, España',
  quote: "Pensaba que sería demasiado restrictivo, pero el recetario tiene más de 50 recetas que realmente me gustan. Sobre todo me ha servido el Kit para Comer Fuera, porque me ayuda a organizarme cuando salgo a restaurantes o quedo con amigos."
}, {
  initials: 'DM',
  name: 'Diego M.',
  location: 'Málaga, España',
  quote: "Me gustó encontrar toda la información organizada de forma clara y progresiva. En vez de ir probando cosas al azar, ahora tengo una estructura que puedo seguir paso a paso."
}, {
  initials: 'FG',
  name: 'Fernanda G.',
  location: 'Bilbao, España',
  quote: "Al principio dudé porque pensé que sería otro ebook genérico, pero me sorprendió. Me sentí identificada con muchas de las situaciones que describe y me gustó especialmente que todo estuviera organizado de manera práctica."
}, {
  initials: 'RH',
  name: 'Rosa H.',
  location: 'Zaragoza, España',
  quote: "Lo que más valoro es tenerlo todo en un mismo sitio. Está organizado, es fácil de entender y puedes empezar a aplicarlo poco a poco."
}, {
  initials: 'LP',
  name: 'Laura P.',
  location: 'Alicante, España',
  quote: "Lo que más me ha ayudado es entender que no hace falta hacerlo todo perfecto. Si un día me salgo de la rutina, simplemente vuelvo a los hábitos básicos y continúo."
}];

export const currencies: string[] = ['Euros'];

export const faqs: Faq[] = [{
  question: '¿Cómo recibo el MegaPack después de comprar?',
  answer: [
    'De forma inmediata recibirás un correo electrónico de confirmación con el acceso. Los 6 tomos + 5 bonos son archivos PDF descargables.',
    'Puedes leerlos desde tu móvil, tablet u ordenador, o imprimirlos si lo prefieres. No es un producto físico: recibirás acceso digital.'
  ]
}, {
  question: '¿El MegaPack está adaptado para España?',
  answer: [
    'Sí. El contenido está escrito en español y las recomendaciones, alimentos y recetas pueden adaptarse fácilmente a productos disponibles en España.',
    'Además, la Lista Inteligente de Compras incluye alternativas y sustituciones para adaptar el contenido a tus preferencias y disponibilidad.'
  ]
}, {
  question: '¿El protocolo es solo para SIBO o también sirve para la hinchazón general?',
  answer: [
    'El contenido está pensado para personas interesadas en mejorar sus hábitos relacionados con el bienestar digestivo, incluyendo situaciones como hinchazón, gases, digestiones pesadas o sensibilidad a determinados alimentos.',
    'No es un protocolo médico específico para SIBO ni sustituye un diagnóstico profesional.',
    'Si tienes una enfermedad o condición digestiva diagnosticada, consulta con un profesional sanitario antes de realizar cambios importantes en tu alimentación.'
  ]
}, {
  question: '¿El contenido es editable? ¿Puedo modificarlo?',
  answer: [
    'Los archivos se entregan en formato PDF. Puedes imprimirlos, añadir tus propias notas y adaptar los ejemplos a tus necesidades.',
    'No puedes compartir, revender ni redistribuir el contenido. La compra incluye una licencia de uso personal.'
  ]
}, {
  question: '¿Los 5 bonos están incluidos en todas las ofertas?',
  answer: [
    'Sí. Los 5 bonos están incluidos con la compra del MegaPack.',
    'El pack completo, con los 6 tomos y los 5 bonos, está disponible actualmente por 24 €.'
  ]
}, {
  question: '¿Este es un material médico? ¿Sustituye a un profesional?',
  answer: [
    'No. Este es un material educativo e informativo y no sustituye el diagnóstico, tratamiento ni seguimiento de un profesional sanitario.',
    'Si tienes una condición médica diagnosticada, alergias alimentarias, estás embarazada o en periodo de lactancia, tomas medicación o presentas síntomas intensos o persistentes, consulta con un profesional antes de realizar cambios importantes en tu alimentación.',
    'El MegaPack Salud Plena debe entenderse como material educativo complementario, no como sustituto de la atención médica.'
  ]
}, {
  question: '¿Cuánto tiempo se tarda en notar cambios?',
  answer: [
    'Cada persona es diferente y no existe un plazo garantizado. El objetivo del programa de 15 días es ayudarte a organizar tus hábitos, registrar cómo te sientes e identificar patrones relacionados con tu alimentación y estilo de vida.',
    'Los resultados y sensaciones pueden variar según la persona, sus hábitos y sus circunstancias individuales.'
  ]
}, {
  question: '¿Qué pasa si estoy siguiendo el plan y tengo un viaje o un evento social?',
  answer: [
    'El bono "Kit Comer Fuera Sin Inflamarte" incluye ideas y estrategias para restaurantes, reuniones familiares, viajes y otros eventos sociales.',
    'La idea es que puedas adaptar lo aprendido a tu vida cotidiana sin sentir que tienes que seguir una rutina perfecta todo el tiempo.'
  ]
}, {
  question: '¿En qué moneda pago?',
  answer: [
    'En España el precio se muestra y se cobra en euros.',
    'Antes de confirmar la compra podrás ver claramente el importe total que vas a pagar.'
  ]
}, {
  question: '¿Qué pasa si determinados alimentos me sientan mal?',
  answer: [
    'El programa está pensado para que puedas adaptarlo. La estructura de 15 días sirve como punto de partida y puedes ajustarla según tus preferencias y necesidades.',
    'El Diario Anti-Hinchazón te ayuda a registrar alimentos, hábitos y sensaciones para identificar patrones personales.'
  ]
}, {
  question: '¿Qué diferencia al MegaPack de otros materiales?',
  answer: [
    'En lugar de ofrecer información aislada, el MegaPack Salud Plena reúne una estructura progresiva, herramientas prácticas, un plan de 15 días y 5 bonos complementarios.',
    'La idea es que tengas todo organizado en un mismo lugar y puedas empezar a utilizarlo desde el primer día.'
  ]
}];